import styles from "./accordionSingle.module.scss";

import SouthEastIcon from "@mui/icons-material/SouthEast";
import RemoveIcon from "@mui/icons-material/Remove";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import Link from "next/link";
import { processFooterUrl } from "@/lib/urlUtils";
import { AttributionHrefLink } from "@/components/attributionHrefLink/attributionHrefLink";

const AccordionSingle = (props) => {
  const [expanded, setExpanded] = useState(false);
  const { t } = useTranslation();

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded);
    props.setSelectedId(panel);
  };

  useEffect(() => {
    // Convert id to number for proper comparison
    const idNum = parseInt(props.id, 10);
    if (idNum === 0) {
      setExpanded(true);
    } else {
      setExpanded(false);
    }
  }, [props.id]);

  useEffect(() => {
    // Convert both selectedId and id to numbers for proper comparison
    const selectedIdNum = parseInt(props.selectedId, 10);
    const idNum = parseInt(props.id, 10);
    if (selectedIdNum === idNum) {
      setExpanded(true);
    } else {
      setExpanded(false);
    }
  }, [props.selectedId, props.id]);

  return (
    <MuiAccordion
      disableGutters
      elevation={0}
      square
      expanded={expanded}
      onChange={
        props.footerList ? undefined : handleChange(parseInt(props.id, 10))
      }
      slotProps={{ transition: { timeout: 600 } }}
      className={`${props.Light ? styles["light"] : ""} ${
        styles["MuiAccordion-root-custom"]
      } ${expanded ? styles["expanded"] : ""}  ${
        props.footerList ? styles["footerAccordion"] : ""
      }`}
    >
      <MuiAccordionSummary
        aria-controls={`${props.Title}-content`}
        id={`${props.id}-header`}
        className={`${styles["MuiAccordionSummary-root-custom"]}`}
        expandIcon={
          expanded ? (
            <RemoveIcon className={`${styles["expanededIcon"]}`} />
          ) : (
            <SouthEastIcon className={`${styles["unExpanededIcon"]}`} />
          )
        }
        onClick={
          props.footerList
            ? (e) => {
                e.preventDefault();
                e.stopPropagation();
                handleChange(parseInt(props.id, 10))(e, !expanded);
              }
            : undefined
        }
      >
        <div className="Acccontnet">{props.title}</div>
      </MuiAccordionSummary>
      <MuiAccordionDetails
        className={`${styles["MuiAccordionDetails-root-custom"]} `}
        onClick={(e) => {
          // Prevent accordion from closing when clicking inside details
          e.stopPropagation();
        }}
      >
        <div className={`${styles["subTitle"]}`}>{props.subTitle}</div>

        {props.footerList ? (
          <>
            <div
              className={`${styles["footerLinks"]}`}
              onClick={(e) => {
                // Allow clicks to pass through to links
                e.stopPropagation();
              }}
            >
              {props.description &&
                props.description.map((itemLink) => {
                  if (props.title === "Solutions") {
                    return (
                      <Link
                        href={`/en/solutions/${itemLink.slug}/`}
                        key={itemLink.id}
                        className={`${styles["footerLink"]}`}
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                      >
                        {itemLink?.acf.hero_title}
                      </Link>
                    );
                  } else if (props.title === "Legal") {
                    return (
                      <Link
                        href={`/en/legal/${itemLink.slug}/`}
                        key={itemLink.id}
                        className={`${styles["footerLink"]}`}
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                      >
                        {itemLink.title.rendered}
                      </Link>
                    );
                  } else if (props.title === "Products") {
                    if (itemLink?.acf.isdynamic) {
                      return (
                        <Link
                          href={`/en/products/${itemLink.slug}/`}
                          key={itemLink.id}
                          className={`${styles["footerLink"]}`}
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                        >
                          {itemLink?.acf.hero_title}
                        </Link>
                      );
                    }
                    return null;
                  } else {
                    const processedUrl = processFooterUrl(itemLink.url, t);
                    // Only render link if we have a valid URL
                    if (
                      processedUrl &&
                      processedUrl !== "undefined" &&
                      processedUrl !== "null"
                    ) {
                      const isDashboardSignup =
                        itemLink.url === "dashboard_url" ||
                        (typeof processedUrl === "string" &&
                          processedUrl.includes("/account/create"));

                      if (isDashboardSignup) {
                        return (
                          <AttributionHrefLink
                            href={processedUrl}
                            key={t(itemLink.title)}
                            className={`${styles["footerLink"]}`}
                            onClick={(e) => {
                              e.stopPropagation();
                            }}
                            {...(itemLink.openInNewTab
                              ? {
                                  target: "_blank",
                                  rel: "noopener noreferrer",
                                }
                              : {})}
                          >
                            {t(itemLink.title)}
                          </AttributionHrefLink>
                        );
                      }

                      return (
                        <Link
                          href={processedUrl}
                          key={t(itemLink.title)}
                          className={`${styles["footerLink"]}`}
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                          {...(itemLink.openInNewTab
                            ? {
                                target: "_blank",
                                rel: "noopener noreferrer",
                              }
                            : {})}
                        >
                          {t(itemLink.title)}
                        </Link>
                      );
                    }
                    return null;
                  }
                })}
            </div>
          </>
        ) : (
          <>
            <div
              className={`${styles["description"]}`}
              dangerouslySetInnerHTML={{ __html: props.description }}
            ></div>
          </>
        )}
      </MuiAccordionDetails>
    </MuiAccordion>
  );
};
export default AccordionSingle;
